module.exports = __webpack_public_path__ + "static/media/Photo19.29ae9a70.jpg";